export default __webpack_public_path__ + "111a9ba.png";